interface RoundedImgProps {
  size: number;
  img_path: string;
}

export default function RoundedImg({ size, img_path }: RoundedImgProps) {
  const gradientStyle = {
    background:
      "linear-gradient(185deg, var(--color-brand-1) 0%, var(--color-brand-2) 39%, var(--color-brand-3) 91.67%)",
    boxShadow: "0 1px 0 0 rgba(255, 255, 255, 0.50) inset",
  };

  return (
    <div
      className="rounded-full p-[1px]"
      style={{
        ...gradientStyle,
        width: `${size}px`,
        height: `${size}px`,
      }}
    >
      <img
        src={img_path}
        alt=""
        className="rounded-full w-full h-full object-cover"
      />
    </div>
  );
}